import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import Help from "../../components/Help";
import DeployTrigger from "../../components/DeployTrigger";
import { helpPagesData } from "../../utils/helper";
import Paginate from "../../components/pagination";
import { NavLink } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import edit from "../../assets/pen1.svg";
import deleteicon from "../../assets/trash.svg";
import { useToast } from "../../components/ToastProvider";
import CommonModal from "../../components/CommonModal";
import { fetchProjectList, deleteProject, UpdateProject, fetchProjectDetail } from "../../action/Projectsaction";

const Projects = () => {
    const { showToast } = useToast();
    const [loadingButton, setLoadingButton] = useState(null);

    const [projects, setProjects] = useState([]);
    const [loader, setLoader] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    const [form, setForm] = useState({
        name: "",
        email: "",
        mobile: "",
        domains: [],
        organization_id: ""
    });

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
    });

    const loadProjects = async () => {
        setLoader(true);
        const res = await fetchProjectList(pagination.page, pagination.limit);
        if (res?.status === 1) {
            setProjects(res.data.list);
            setPagination((prev) => ({
                ...prev,
                total: Math.ceil(res.data.total / pagination.limit),
            }));
        }
        setLoader(false);
    };

    useEffect(() => {
        loadProjects();
    }, [pagination.page]);

    const handleEdit = async (id) => {
        const result = await fetchProjectDetail(id);
        if (result?.status === 1) {
            const p = result.data;
            setSelectedProject(p);
            setForm({
                name: p.name,
                email: p.email,
                mobile: p.mobile,
                domains: p.domains,
                organization_id: p.organization_id?._id,
            });
            setEditModal(true);
        }
    };

    const saveEdit = async () => {
        const res = await UpdateProject(selectedProject._id, form);
        if (res?.status === 1) {
            showToast("Project updated successfully", "success");
            setEditModal(false);
            loadProjects();
        } else {
            showToast(res?.message || "Failed to update", "error");
        }
    };

    const confirmDelete = async () => {
        const res = await deleteProject(selectedProject._id);
        if (res?.status === 1) {
            showToast("Project deleted", "success");
            setDeleteModal(false);
            loadProjects();
        }
    };

    return (
        <>
            <PageHeader pageTitle="Projects">
                    <Help title={helpPagesData.pages.title} message={helpPagesData.pages.message} items={helpPagesData.pages.items} />
                    <NavLink to="/projects/add" className="btn-black">Add Project</NavLink>
            </PageHeader>

            {loader ? (
                <div className="text-center py-5"><Spinner /></div>
            ) : (
                <div className="page-container">
                    <div className="theme-card p-4">
                        <div className="card-title pb-3">Overview</div>

                        <table className="pages-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Domains</th>
                                    <th>Organization</th>
                                    <th style={{ textAlign: "center" }}>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {projects.map((p) => (
                                    <tr key={p._id}>
                                        <td>{p.name}</td>
                                        <td>{p.email}</td>
                                        <td>{p.domains.join(", ")}</td>
                                        <td>{p.organization_id?.name}</td>
                                        <td style={{ textAlign: "center" }}>
                                            <div className="three-btn">
                                                <img src={edit} alt="icon" onClick={() => handleEdit(p._id)} />
                                                <img src={deleteicon} alt="icon" onClick={() => {
                                                    setSelectedProject(p);
                                                    setDeleteModal(true);
                                                }} />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {pagination.total > 1 && (
                            <Paginate
                                currentPage={pagination.page}
                                totalPages={pagination.total}
                                onPageChange={(page) => setPagination((p) => ({ ...p, page }))}
                            />
                        )}
                    </div>
                </div>
            )}

            {/* EDIT MODAL */}
            {editModal && (
                <CommonModal show={editModal} onClose={() => setEditModal(false)} width="450px">
                    <div class="card-header-title">Edit Project</div>

                    <label className="frm-label">Name</label>
                    <input className="frm-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />

                    <label className="frm-label">Email</label>
                    <input className="frm-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />

                    <label className="frm-label">Mobile</label>
                    <input className="frm-input" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} />

                    <label className="frm-label">Domains (comma separated)</label>
                    <input
                        className="frm-input"
                        value={form.domains.join(",")}
                        onChange={(e) => setForm({ ...form, domains: e.target.value.split(",") })}
                    />

                    <div className="modal-actions mt-4">
                        <button className="btn-white" onClick={() => setEditModal(false)}>Cancel</button>
                        <button className="btn-black" onClick={saveEdit}>Update</button>
                    </div>
                </CommonModal>
            )}

            {/* DELETE CONFIRMATION */}
            {deleteModal && (
                <div className="popup-overlay">
                    <div className="popup-container">
                        <h4 className="popup-title">Delete Project?</h4>

                        <p className="popup-message">
                            Are you sure you want to delete <b>{selectedProject?.name}</b>? This action cannot be undone.
                        </p>

                        <div className="popup-actions">
                            <button
                                className="btn-white"
                                onClick={() => setDeleteModal(false)}
                                disabled={loadingButton === "delete"}
                            >
                                No
                            </button>

                            <button
                                className="btn-red"
                                onClick={async () => {
                                    setLoadingButton("delete");
                                    await confirmDelete();
                                    setLoadingButton(null);
                                }}
                                disabled={loadingButton === "delete"}
                            >
                                {loadingButton === "delete" ? "Deleting..." : "Yes, Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default Projects;
